export default "__VITE_ASSET__BtWEERqC__"